import styled from '@emotion/styled';
import { screenSizes } from 'src/assets/styles/Literals';

export const DashboardGroupsComponent = styled.div`
  width: 85%;
  height: 86vh;
  box-sizing: border-box;
  background-color: #f4f5f7;
  position: fixed;
  right: 0;
  overflow-x: hidden;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  padding: 12px 16px 32px;

  .h2Title {
    color: #1d1d1b;
    font-size: 28px;
    margin: 4px 8px 8px;
    font-weight: 700;
  }

  .h4Title {
    margin: 0;
    font-size: 13px;
    font-weight: 600;
    color: #5c5c5c;
  }

  .dashboard-body {
    width: 100%;
    flex: 1 0 auto;
  }

  .ui.attached.tabular.menu {
    margin-bottom: 0;
    border: none;
    background: transparent;
  }

  .ui.tabular.menu .item {
    font-weight: 600;
  }

  .ui.bottom.attached.tab.segment,
  .ui.attached.segment {
    border: none;
    box-shadow: none;
    background: transparent;
    padding: 12px 0 0;
    overflow: visible;
  }

  .groupsContainer {
    overflow: visible;
    padding: 0 4px 48px;
  }

  .dashboard-toolbar,
  .generationSelector,
  .date-filter {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-end;
    gap: 12px 20px;
    background: #fff;
    border: 1px solid #ececec;
    border-radius: 12px;
    padding: 12px 16px;
    margin-bottom: 16px;
  }

  .date-filter {
    height: auto;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }

  .date-filter__row {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px;
  }

  .date-filter input,
  .selectCategory {
    padding: 8px 10px;
    border-radius: 8px;
    border: 1px solid #cfcfcf;
    background: #fff;
    font-size: 14px;
  }

  .date-filter button {
    padding: 8px 14px;
    border: none;
    border-radius: 8px;
    background: #1d1d1b;
    color: #fff;
    cursor: pointer;
    font-weight: 600;
  }

  .generationSelector {
    justify-content: flex-start;
  }

  .selectCategory {
    min-width: 240px;
  }

  .chart-section-header {
    display: flex;
    align-items: center;
    gap: 10px;
    margin: 8px 4px 12px;
    padding: 0 4px;

    h3 {
      margin: 0;
      font-size: 18px;
      font-weight: 700;
      color: #1d1d1b;
      text-align: left;
    }

    .ui.icon {
      color: #fc9133;
    }

    .chart-section-filter {
      margin-left: auto;
      font-size: 13px;
      font-weight: 600;
      color: #6b6b6b;
      background: #fff;
      border: 1px solid #ececec;
      border-radius: 999px;
      padding: 4px 10px;
    }
  }

  .totalLabels {
    align-items: center;
    display: flex;
    justify-content: flex-start;
    font-weight: 600;
    color: #434343;
    margin: 0 8px 8px;
    font-size: 14px;
  }

  .chartSection {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
    gap: 16px;
    justify-content: stretch;
    margin-bottom: 20px;
    align-items: stretch;
  }

  .chartSection--disciples {
    grid-template-columns: minmax(260px, 340px) minmax(0, 1fr);
  }

  .graphic--wide {
    min-width: 0;
    padding: 16px 16px 12px;
  }

  .growth-chart {
    width: 100%;
    min-height: 380px;
  }

  .growth-tooltip {
    background: #fff;
    border: 1px solid #ececec;
    border-radius: 8px;
    padding: 8px 10px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    font-size: 13px;
    color: #434343;

    strong {
      display: block;
      margin-bottom: 4px;
      color: #1d1d1b;
    }
  }

  .graphic,
  .pie-chart {
    width: 100%;
    max-width: none;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 0;
    background: #fff;
    border: 1px solid #ececec;
    border-radius: 16px;
    padding: 12px 8px 8px;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
  }

  .graphic p,
  .pie-chart p,
  .pie-subtitle {
    margin: 0 0 4px;
    color: #6b6b6b;
    font-size: 13px;
    text-align: center;
  }

  .chart-empty {
    min-height: 220px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #8a8a8a;
    font-size: 14px;
  }

  .chart-note {
    font-size: 12px;
    color: #6b6b6b;
    padding: 0 12px 8px;
    text-align: left;
    line-height: 1.4;
  }

  h3 {
    color: #1d1d1b;
    font-size: 15px;
    text-align: center;
    margin: 0 8px 4px;
    font-weight: 700;
    line-height: 1.3;
  }

  @media (max-width: ${screenSizes.laptop}) {
    width: 100%;
    height: calc(100vh - 70px);
    position: relative;

    .chartSection--disciples {
      grid-template-columns: 1fr;
    }
  }
`;
